import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import useUserAccount from "../hooks/useUserAccount";
import useEnv from "../hooks/useEnv";

import illustrationJpg01 from '../img/03-manage-invoices.jpg';
import illustrationAvif01 from '../img/03-manage-invoices.avif';
import illustrationJpg02 from '../img/04-help-with-invoices.jpg';
import illustrationAvif02 from '../img/04-help-with-invoices.avif';
import illustrationJpg03 from '../img/01-contact.jpg';
import illustrationAvif03 from '../img/01-contact.avif';
import useI18n from "../hooks/useI18n";

const Landing5th = ({ locale }) => {
    const { isEnvTruthy, getEnv } = useEnv();
    const { getCountry } = useI18n();
    const { personalAuthLink, companyAuthLink } = useUserAccount();

    const resolveTranslationForCountry = (localeObj) => {
        const country = getCountry();
        if (Object.keys(localeObj).includes(country)) {
            return localeObj[country];
        }
        return localeObj.default ?? '';
    }

    const CTAColumn = [
        {
            key: "manageinvoices",
            illustrationAvif: illustrationAvif01,
            illustrationJpg: illustrationJpg01,
            title: locale.manageCompanyInvoices,
            description: resolveTranslationForCountry(locale.manageCompanyInvoicesDescription),
            buttonText: locale.manageCompanyInvoices,
            link: isEnvTruthy('COMPANY_TOGGLE') ? companyAuthLink : personalAuthLink,
            externalLink: false,
            hrElement: true
        },
        {
            key: "helpwithinvoices",
            illustrationAvif: illustrationAvif02,
            illustrationJpg: illustrationJpg02,
            title: locale.helpWithInvoices,
            description: locale.helpWithInvoicesDescription,
            buttonText: locale.helpWithInvoicesButton,
            link: personalAuthLink,
            externalLink: false,
            hrElement: true
        },
        {
            key: "contact",
            illustrationAvif: illustrationAvif03,
            illustrationJpg: illustrationJpg03,
            title: locale.noBankIDAccess,
            description: locale.noBankIDAccessDescription,
            buttonText: locale.noBankIDAccessButton,
            link: getEnv('CONTACT_FORM_URL') ?? '#',
            externalLink: true,
            hrElement: false
        }
    ];

    return (
        <div className='landing-element-container' id="landing-page-5th">
            <div className='landing-element-content'>
                <div className="row">
                    <div className='col-12'>
                        <h1>{locale.title}</h1>
                    </div>
                </div>
                <div className="row d-flex">
                    {CTAColumn.map((column) => (
                        <div className="col-md-4 col-sm-12 d-flex flex-column mt-4 mb-4" key={column.key}>
                            <picture>
                                <source srcSet={column.illustrationAvif} type="image/avif" />
                                <img
                                    loading='lazy'
                                    alt={column.title}
                                    src={column.illustrationJpg}
                                    aria-hidden
                                    className="img-fluid rounded-4 mb-4"
                                />
                            </picture>
                            <h5>{column.title}</h5>
                            <p>{column.description}</p>
                            {!column.externalLink ?
                                <Link
                                    className="btn btn-landing-cta"
                                    to={column.link}
                                    aria-label={column.buttonText}
                                >
                                    {column.buttonText}
                                </Link> :
                                <a href={column.link} className="btn btn-landing-cta">
                                    {column.buttonText}
                                </a>
                            }
                            {column.hrElement && (
                                <hr
                                    className="d-md-none d-sm-block mt-4"
                                    style={{ marginLeft: 0, marginRight: 0 }}
                                />
                            )}
                        </div>
                    ))}
                    <hr className="d-md-block d-sm-none d-none" />
                </div>
            </div>
        </div >
    )
}

Landing5th.propTypes = {
    locale: PropTypes.object.isRequired
}

export default Landing5th;
